import { render, staticRenderFns } from "./ModuleTemplate.vue?vue&type=template&id=11a014fe&"
import script from "./ModuleTemplate.vue?vue&type=script&lang=js&"
export * from "./ModuleTemplate.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTemplate.vue?vue&type=style&index=0&id=11a014fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports